/** 媒体账号状态选项（与后端 MediaStatus 枚举一致） */
const MEDIA_ACCOUNT_STATUS_OPTIONS = [
  { label: '活跃', value: 1 },
  { label: '不活跃', value: 2 },
  { label: '弃用', value: 3 },
];

/**
 * 编辑账号状态表单配置
 * @param {string} account_status 当前状态文案，用于下拉回显
 */
module.exports = (account_status) => {
  const option = MEDIA_ACCOUNT_STATUS_OPTIONS.find(item => item.label === account_status);
  return {
    status: {
      label: '账号状态',
      type: 'radio-group',
      options: MEDIA_ACCOUNT_STATUS_OPTIONS,
      formItemTips: {
        content: '设为不活跃/弃用后，该账号将停止定时拉取报表与余额（仅活跃账号参与）',
        props: { style: 'color: #F56C6C;' },
      },
      value: option ? option.value : '',
    },
  };
};

// 供批量修改账号状态复用
module.exports.options = MEDIA_ACCOUNT_STATUS_OPTIONS;
